import { useHits } from 'react-instantsearch';
import { HitFaq } from '../types';
import TableFaqItem from '@/components/table/TableFaqItem';

export default function CustomHitsFaq() {
  const { hits, results } = useHits<HitFaq>({});
  return (
    <>
      <div className="max-w-auto flex items-center pb-6 lg:max-w-container">
        <div className="flex w-full flex-col px-10 py-10 md:px-40">
          {hits.map((hit) => {
            const { id, question, answer } = hit;
            return (
              <TableFaqItem
                key={id}
                id={id}
                question={question}
                answer={answer}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}
